import React from 'react';
import { useHistory } from 'react-router-dom';
import noWaves from 'assets/images/noWaves.png';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import {
	Container,
	MainMessage,
	SecondaryMessage,
} from './styles';

const NoInitiatives = () => {
	const history = useHistory();
	return (
		<Container>
			<img src={noWaves} alt="no initiatives" width={370} />
			<MainMessage>
				You can only plan your waves when you have
				created initiatives
			</MainMessage>
			<SecondaryMessage>
				Please create your initiatives then plan the execution by allocating them to waves
			</SecondaryMessage>
			<ApButtonSecondary onClick={() => {
				history.push('/initiatives');
			}}>
				go to the initiatives page
			</ApButtonSecondary>
		</Container>
	)
}

export default NoInitiatives;
